import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import detalle_solicitud from 'views/components/crm/store/detalle_solicitud.js';
import empresa from 'views/components/crm/store/empresa.js';
import ui from 'views/components/crm/store/ui.js';
import pagina from 'views/components/crm/store/pagina.js';
import axiosClient from 'views/components/crm/api/axiosClient';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    store_detalle_solicitud: detalle_solicitud,
    store_empresa: empresa,
    ui,
    pagina,
  },
  state: {
    // Datos de la sesión del usuario
    empresa: {
      clave: 0,
      id: 0,
      logo: '',
      plan_web_pagado: null,
      tipo: '',
      token: '',
      username: '',
    },
    membresia: {
      fecha_creacion: null,
      fecha_expiracion: null,
    },
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    setEmpresa(state, empresa = {}) {
      state.empresa = {
        ...state.empresa,
        ...empresa,
      };
    },
  },
  actions: {
    async login(_, { usuario, contrasena }) {
      const { data } = await axiosClient.post('/web/validar', {
        usuario,
        contrasena,
      });

      if (data.status === 'error') {
        return data;
      }

      this.commit('setEmpresa', data);

      return data;
    },
  },
});
